import * as React from "react";
import styled from "styled-components";

import { FormContext } from "../context/FormContextProvider";
import { Checkbox } from "./Checkbox";
import { useCheckActiveOffice } from "../../../../utils/hooks/useCheckActiveOffice";

import { GetPropertyVisningspaamelding } from "../../../../../__types__/generated/GetPropertyVisningspaamelding";
import { InputError } from "./InputError";
import { useQuery } from "@apollo/client";
import { GET_CONSENTS } from "../graphql/queries";
import { client } from "../../../../../../client/__graphql__/client";
import { GET_SHOWING_SETTINGS_QUERY } from "../../../../../../client/__graphql__/queries/getShowingSettings";
import { rtcluster } from "../../../../../../client/__graphql__/rtcluster";
import { isNordeaFinancingAvailable } from "../utils/isNordeaFinancingAvailable";

interface IConsents {
  showValuation?: boolean;
  showPrinted?: boolean;
  printedConsentError?: string;
  data: GetPropertyVisningspaamelding;
  marketing?: boolean;
}

export const Consents: React.FC<IConsents> = React.memo(
  ({ showValuation, showPrinted, printedConsentError, data, marketing }) => {
    const {
      valuation,
      setValuation,
      printed,
      setPrinted,
      setSamtykkeIds,
      samtykkeIds,
    } = React.useContext(FormContext);
    const { active } = useCheckActiveOffice();

    const { wmId } = data?.getProperty ?? ({} as any);

    const { data: settings, loading: settingsLoading } = useQuery(
      GET_SHOWING_SETTINGS_QUERY,
      {
        client: rtcluster,
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
        variables: {
          input: {
            brandId: "privatmegleren",
            estateId: wmId,
          },
        },
      }
    );

    const {
      data: consents,
      loading,
      error,
    } = useQuery(GET_CONSENTS, {
      client: client,
      variables: { ids: [5, 7] },
      fetchPolicy: "cache-first",
    });

    if (loading || settingsLoading) return null;

    return (
      <>
        {active &&
        showPrinted &&
        data?.getProperty?.assignmentType !== "NYBYGG" &&
        !data?.getProperty?.type?.match(/tomt/g) &&
        data?.getProperty?.hovedoppdrag !== -1 ? (
          <>
            {printedConsentError ? (
              <InputError style={{ marginTop: "30px", marginBottom: 0 }}>
                {printedConsentError}
              </InputError>
            ) : null}
            <StyledConsents
              style={{ marginTop: printedConsentError ? "10px" : "30px" }}
            >
              <h3>
                Bestill trykket boligpresentasjon til visning. (Kostnadsfritt)
              </h3>
              <Checkbox
                labelPos="right"
                label="Ja takk."
                checked={printed}
                onClick={() => setPrinted(!printed)}
              />
            </StyledConsents>
          </>
        ) : null}

        {showValuation ? (
          <StyledConsents>
            <h1>Verdivurdering av din bolig?</h1>
            <Checkbox
              labelPos="right"
              label="Jeg ønsker å bli kontaktet for verdivurdering av egen bolig."
              checked={valuation}
              onClick={() => setValuation(!valuation)}
            />
          </StyledConsents>
        ) : null}

        {marketing &&
        Array.isArray(consents?.getAvailableSamtykkerByIds) &&
        consents?.getAvailableSamtykkerByIds?.length ? (
          <StyledConsents className="marketing">
            {consents?.getAvailableSamtykkerByIds
              ?.filter((e: any) => e?.id)
              ?.map((consent: any, index: number) => {
                const { id, samtykketekst: label } = consent ?? {};
                if (!id) return null;
                if (id === 5) {
                  return null;
                  if (!isNordeaFinancingAvailable(settings)) return null;
                  return (
                    <StyledConsents className="align-left">
                      <h2>Finansiering fra Nordea?</h2>
                      <Checkbox
                        key={`consent${index}`}
                        labelPos="right"
                        label={label}
                        checked={samtykkeIds.includes(id)}
                        onClick={() => setSamtykkeIds(id)}
                      />
                    </StyledConsents>
                  );
                }
                return (
                  <Checkbox
                    key={`consent${index}`}
                    labelPos="right"
                    label={label}
                    checked={samtykkeIds.includes(id)}
                    onClick={() => setSamtykkeIds(id)}
                  />
                );
              })}
          </StyledConsents>
        ) : null}
      </>
    );
  }
);

/*

<StyledConsents>
          <h2>Finansiering fra Nordea?</h2>
          <Checkbox
            labelPos="right"
            label="Jeg ønsker å bli kontaktet for verdivurdering av egen bolig."
            checked={valuation}
            onClick={() => setValuation(!valuation)}
          />
        </StyledConsents>
*/

const StyledConsents = styled.div`
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background: rgb(40, 40, 40);
  display: flex;
  flex-direction: column;
  gap: 1em;

  h1 {
    margin-top: 0;
    font-size: 28px;
    text-align: left !important;
  }

  h3 {
    font-size: 1.3em;
    margin-top: 0;
    text-align: left !important;
  }

  p {
    margin-top: 0;
    margin-bottom: 20px;
    text-align: left !important;
  }
  &.marketing {
    padding: 20px 0;
    background: none;
  }

  &.align-left {
    align-items: flex-start;
    h2 {
      margin: 0;
    }

    .checkbox-label {
      font-size: 0.9rem;
    }
  }
`;
